import { useEffect } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import confetti from "canvas-confetti";

const KEY = "sc_last_invited";

// On app load, celebrate when a member's referral link has earned new friends
// since we last checked, and show progress toward the next reward badge.
export function InviteRewardNudge() {
  useEffect(() => {
    let cancel = false;
    client.get("/auth/referral").then((r) => {
      if (cancel) return;
      const d = r.data || {};
      const count = d.invited_count || 0;
      const raw = localStorage.getItem(KEY);
      if (raw === null) { localStorage.setItem(KEY, String(count)); return; }
      const prev = parseInt(raw, 10) || 0;
      if (count > prev) {
        const gained = count - prev;
        const newBadge = (d.ladder || []).filter((m) => m.count > prev && m.count <= count).slice(-1)[0];
        const next = d.rewards?.next_badge;
        const toNext = d.rewards?.to_next;
        const progress = next ? ` ${toNext} more to “${next}”.` : "";
        confetti({ particleCount: 150, spread: 80, origin: { y: 0.35 }, colors: ["#D4AF37", "#E8C86A", "#ffffff"] });
        if (newBadge) {
          toast.success(`🏆 Badge unlocked: “${newBadge.badge}”! ${gained} friend${gained > 1 ? "s" : ""} joined from your invite.${progress}`, { duration: 7000 });
        } else {
          toast.success(`🎉 ${gained} new friend${gained > 1 ? "s" : ""} joined from your invite — that's ${count} month${count > 1 ? "s" : ""} of Premiere earned!${progress}`, { duration: 7000 });
        }
      }
      localStorage.setItem(KEY, String(count));
    }).catch(() => {});
    return () => { cancel = true; };
  }, []);
  return null;
}
